import { defineComponent as p, openBlock as o, createElementBlock as e, mergeProps as u, unref as l, renderSlot as V, createElementVNode as a, createCommentVNode as g } from "vue";
import { useScalarIcon as M } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, m = { key: 1 }, f = { key: 2 }, h = { key: 3 }, k = { key: 4 }, A = { key: 5 }, w = {
  name: "ScalarIconCaretLineRight"
}, L = /* @__PURE__ */ p({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = M(s);
    return (i, t) => (o(), e("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(d)), [
      V(i.$slots, "default"),
      l(n) === "bold" ? (o(), e("g", Z, t[0] || (t[0] = [
        a("path", { d: "M152.49,119.51a12,12,0,0,1,0,17l-80,80a12,12,0,0,1-17-17L127,128,55.51,56.49a12,12,0,0,1,17-17ZM184,36a12,12,0,0,0-12,12V208a12,12,0,0,0,24,0V48A12,12,0,0,0,184,36Z" }, null, -1)
      ]))) : l(n) === "duotone" ? (o(), e("g", m, t[1] || (t[1] = [
        a("path", {
          d: "M144,128,64,208V48Z",
          opacity: "0.2"
        }, null, -1),
        a("path", { d: "M69.66,42.34A8,8,0,0,0,56,48V208a8,8,0,0,0,13.66,5.66l80-80a8,8,0,0,0,0-11.32ZM72,188.69V67.31L132.69,128ZM192,48V208a8,8,0,0,1-16,0V48a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : l(n) === "fill" ? (o(), e("g", f, t[2] || (t[2] = [
        a("path", { d: "M149.66,122.34a8,8,0,0,1,0,11.32l-80,80A8,8,0,0,1,56,208V48a8,8,0,0,1,13.66-5.66ZM184,40a8,8,0,0,0-8,8V208a8,8,0,0,0,16,0V48A8,8,0,0,0,184,40Z" }, null, -1)
      ]))) : l(n) === "light" ? (o(), e("g", h, t[3] || (t[3] = [
        a("path", { d: "M148.24,123.76a6,6,0,0,1,0,8.48l-80,80a6,6,0,0,1-8.48-8.48L135.51,128,59.76,52.24a6,6,0,0,1,8.48-8.48ZM184,42a6,6,0,0,0-6,6V208a6,6,0,0,0,12,0V48A6,6,0,0,0,184,42Z" }, null, -1)
      ]))) : l(n) === "regular" ? (o(), e("g", k, t[4] || (t[4] = [
        a("path", { d: "M149.66,122.34a8,8,0,0,1,0,11.32l-80,80a8,8,0,0,1-11.32-11.32L132.69,128,58.34,53.66A8,8,0,0,1,69.66,42.34ZM184,40a8,8,0,0,0-8,8V208a8,8,0,0,0,16,0V48A8,8,0,0,0,184,40Z" }, null, -1)
      ]))) : l(n) === "thin" ? (o(), e("g", A, t[5] || (t[5] = [
        a("path", { d: "M146.83,125.17a4,4,0,0,1,0,5.66l-80,80a4,4,0,0,1-5.66-5.66L138.34,128,61.17,50.83a4,4,0,0,1,5.66-5.66ZM184,44a4,4,0,0,0-4,4V208a4,4,0,0,0,8,0V48A4,4,0,0,0,184,44Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  L as default
};
